import * as React from 'react';
import { Nav, NavItem } from 'reactstrap';
import { LogoutButton } from './LogoutButton';
import { getEnvironmentBannerConfig } from '../utils/environment';

const bannerStyles = require('./environment-banner.css');

export const EnvironmentBanner = () => {
  const config = getEnvironmentBannerConfig();

  if (!config) {
    return null;
  }

  return (
    <div className={bannerStyles[config.bannerClassName]}>
      <div className={bannerStyles['uat-environment-banner-left']}>
        <span
          className={bannerStyles['uat-environment-logo']}
          aria-label={config.label}
        >
          {config.label}
        </span>
        <span className={bannerStyles['uat-environment-message']}>
          {config.message}
        </span>
      </div>
      <Nav className={bannerStyles['uat-environment-banner-nav']} navbar>
        <NavItem>
          <LogoutButton
            inBanner
            bannerClassName={bannerStyles['uat-environment-logout-btn']}
          />
        </NavItem>
      </Nav>
    </div>
  );
};
